import store from 'store2';
import { get } from 'lodash';

import config from 'config';
import media from './media';
import { MssgApiClient } from './client';

const api = new MssgApiClient({
    baseUrl: process.env.REACT_APP_API_URL || '/api',
    socketUrl: config.websocket_url,
});

function setDefaultWorkspace() {
    const workspaceId = get(api.aboutMe, 'workspaces[0].workspace');
    api.param('workspaceId', workspaceId);
    // TODO: remove
    store.set('currentWorkspace', workspaceId);
}

if (api.isAuthenticated) {
    setDefaultWorkspace();
}

api.on('changeAccessToken', () => {
    setDefaultWorkspace();
});

export default api;

export { media };
